<!-- App Main Structure -->
<template>
  <a-layout data-testid="base-layout">
    <a-layout-header>
      <Header
        v-if="
          !isViewer && (isMobile ? $route?.meta?.showHeader !== false : true)
        "
      />
      <ViewerHeader v-if="isViewer" />
    </a-layout-header>
    <a-layout-content>
      <template>
        <MobileTopBanner
          id="notAuthBanner"
          v-if="isMobile && !user && !isViewer"
        >
          <AuthLockBlock>
            <div class="demo__color--white">
              {{ $t("Auth banner text") }}
            </div>
          </AuthLockBlock>
        </MobileTopBanner>
        <transition name="router-anim" :enter-active-class="`animated fade`">
          <router-view />
        </transition>
      </template>
    </a-layout-content>
    <FooterMobileMenu v-if="isMobile && !isViewer" />
    <AnyImageModal />
  </a-layout>
</template>
<script>
import { mapGetters } from "vuex";
import Header from "Components/Header";
import ViewerHeader from "Components/Viewer/components/Header";
import FooterMobileMenu from "Components/FooterMobileMenu";
import MobileTopBanner from "Components/MobileTopBanner";
import AnyImageModal from "Components/AnyImageModal";

export default {
  components: {
    Header,
    ViewerHeader,
    FooterMobileMenu,
    MobileTopBanner,
    AnyImageModal,
  },
  computed: {
    ...mapGetters(["windowWidth", "isMobile", "user"]),
    isViewer() {
      return this.$route.path.indexOf("view") !== -1;
    },
  },
  created() {
    this.$accessModule("base_template", this);
  },
};
</script>
